import { Form, Input, Modal } from "antd";
import { useState } from "react";

export default function RejectModal(props) {
  const { open, isProcessing, onSubmit, onCancel } = props;
  const [rejectReason, setRejectReason] = useState("");

  const onChangeRejectReason = (e) => {
    setRejectReason(e.target.value);
  };

  const handleOk = () => {
    if (!rejectReason.trim()) {
      return;
    }
    onSubmit(rejectReason);
    setRejectReason("");
  };

  const handleCancel = () => {
    setRejectReason("");
    onCancel();
  };

  return (
    <Modal
      title="Xác nhận từ chối căn cước công dân"
      okText="Lưu"
      cancelText="Huỷ"
      centered
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      confirmLoading={isProcessing}
    >
      <Form layout="vertical">
        <Form.Item label="Lý do từ chối" required>
          <Input.TextArea
            value={rejectReason}
            onChange={onChangeRejectReason}
            autoSize={{ minRows: 3, maxRows: 6 }}
            placeholder="Nhập lý do từ chối..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
